export default {
  user: {},
  accounts: [],
  showDetailsDevelopment: false,
};
